import React from 'react';

export const TabelaConsumoComponentes = () => {
  return (
    <div className="card mb-2">
      <div className="card-header"><h2 className="card-title h6 mb-0">Consumo de Componentes</h2></div>
      <div className="card-body p-0" style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-sm mb-0">
            <thead>
              <tr>
                <th>Número</th><th>Ordem</th><th>Operação</th><th>Chv.Mod.Apont</th>
                <th>Posição</th><th>Componente</th><th>Descrição</th>
                <th>Qtd. UM Registro</th><th>UM</th><th>Depósito</th>
                <th>Lote</th><th>Tipo Movimentação</th><th>Modificado</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(10)].map((_, index) => (
                <tr key={index}>
                  <td>{index + 1}</td><td>11136933</td><td>2900</td><td>MONTAGEM</td>
                  <td>0104</td><td>100003082</td><td>PVB CLEAR FILM QIL 0.76X1600</td>
                  <td>0,019</td><td>m2</td><td>PP04</td>
                  <td><input type="text" className="form-control form-control-sm" /></td>
                  <td>261</td><td>True</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
